import { Navigate } from "react-router-dom";

function PrivateRoute({ isLoggedIn, children }) {
    if (!isLoggedIn) {
        // Redirect to login if not authorized
        return <Navigate to="/login" replace />;
    }
    return children;
}

export default PrivateRoute;
